import { h as _h } from "gyron";
import { Link } from '@gyron/router';
import { FC } from 'gyron';
export const Mismatch = FC(() => {
  return () => _h("div", {
    "class": "flex flex-auto items-center justify-center text-center px-4 flex-col sm:flex-row h-[calc(100vh-58px)]"
  }, [_h("h1", {
    "class": "text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight sm:pr-6 sm:mr-6 sm:border-r sm:border-slate-900/10 sm:dark:border-slate-300/10 dark:text-slate-200"
  }, "\n        404\n      "), _h("h2", {
    "class": "mt-2 text-lg text-slate-700 dark:text-slate-400 sm:mt-0"
  }, ["\n        \u8D70\u4E22\u4E86\u5417\uFF1F\n        ", _h(Link, {
    "to": "/",
    "replace": true,
    "className": "underline"
  }, "\n          \u70B9\u6211\u56DE\u5230\u4E3B\u9875\n        ")])]);
});